/**
 * NB Campus Verano Landing Page
 *
 * This component is temporaly until the new booking flow is implemented.
 */

import ServiceCard from '@/components/common/cards/service-card/ServiceCard';
import { BookingByGroups } from '@/components/common/forms/booking-datepicker-form-body/Groups';
import ParticipantCampus from '@/components/common/forms/participants-data-form-body/ParticipantCampus';
import { RegisteredUserModal } from '@/components/common/modals/registered-user-modal/RegisteredUserModal';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { useFormLandingCampus } from '@/hooks/business-logic/nb-campus/useFormLandingCampus';
import useMixPanel from '@/hooks/useMixPanel';
import { TOrganizationFAQ } from '@/services/api/organization-api';
import { Service } from '@/services/api/services-api';
import { TUserData } from '@/services/api/user-api';
import { Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import PaymentStep from '../payment-step/PaymentStep';

type Props = {
  organization: TOrganizationFAQ;
  user: TUserData | undefined;
  service: Service;
};

const NBLandingByDivisionGroups = ({ organization, user, service }: Props) => {
  const { t } = useTranslation(['newBooking', 'common']);
  const Mixpanel = useMixPanel();
  const {
    form,
    isPendingSale,
    isSaleCreated,
    onSubmit,
    handleBlur,
    emailHint,
    isOpenRegisteredUserModal,
    setIsOpenRegisteredUserModal
  } = useFormLandingCampus({
    service,
    user
  });

  if (!service) {
    return null;
  }

  if (isPendingSale) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (isSaleCreated) {
    return <PaymentStep organization={organization} />;
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        {service && (
          <div className="flex flex-col gap-10">
            <RegisteredUserModal
              isOpenAlertDialog={isOpenRegisteredUserModal}
              setIsOpenAlertDialog={setIsOpenRegisteredUserModal}
              organization={organization}
              email={emailHint}
              isLanding
              serviceId={service.id}
            />
            <ServiceCard service={service} organization={organization} />
            <BookingByGroups
              form={form}
              tz={organization.tz}
              organization={organization}
              service={service}
              isLanding
            />
            <ParticipantCampus
              form={form}
              handleBlur={handleBlur}
              user={user}
            />
            <Button
              type="submit"
              className="w-full"
              disabled={isPendingSale}
              onClick={() =>
                Mixpanel.track('Press continue button', {
                  screen: 'New Booking Landing',
                  Activity: service.name
                })
              }
            >
              {isPendingSale ? (
                <Loader className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                t('stepParticipants.form.continue')
              )}
            </Button>
          </div>
        )}
      </form>
    </Form>
  );
};

export default NBLandingByDivisionGroups;
